/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultDropdownProps } from 'framework/form';

const TIMESLOT_DURATIONS = {
  30: '30 minutes',
  60: '1 hour',
  90: '1 hour 30 minutes',
};

const TimeslotDurationDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return <EnumDropdown options={TIMESLOT_DURATIONS} placeholder="Choose Timeslot duration" {...props} />;
};

export default TimeslotDurationDropdown;
